import $ from "jquery";

export function ajaxSearch() {
  /*$("#at-ajax-search").keyup(function () {
    console.log("hallo");
  });*/

  var ppp = 5; // Post per page
  var pageNumber = 1;

  function load_posts(
    postType,
    linkId,
    searchValue,
    layout,
    reload = false,
    language = "de"
  ) {
    if (searchValue !== 0) {
      searchValue = "&searchValue=" + searchValue;
    } else {
      searchValue = "";
    }

    if (reload === true) {
      pageNumber++;
    }

    if (layout === 2) {
      ppp = 8;
    } else {
      ppp = 5;
    }
    //var language = $("body").attr("data-language");
    //var language = "de";
    var str =
      "&pageNumber=" +
      pageNumber +
      "&ppp=" +
      ppp +
      searchValue +
      "&action=more_" +
      postType +
      "_ajax" +
      "&layout=" +
      layout;

    var showContainer = "";
    if (layout === 2) {
      showContainer = $("#ajax-search-posts-single");
    } else {
      showContainer = $("#ajax-search-posts");
    }

    //console.log(language);
    $.ajax({
      type: "POST",
      dataType: "html",
      url: ajax_posts.ajaxurl,
      data: str,
      success: function (data) {
        //console.log(data.length);
        var $data = $(data);
        if (data.length > 0) {
          //console.log(data);
          //$("#no-search-posts-found").hide();
          showContainer.show();

          if (reload === true) {
            showContainer.append(data);
          } else {
            showContainer.html(data);
          }

          //$(linkId).removeClass("disabled"); // Uncomment this if you want to disable the button once all posts are loaded
          //$("#more_posts").hide(); // This will hide the button once all posts have been loaded
          $(linkId).show(); // This will hide the button once all posts have been loaded
        } else {
          if (reload === true) {
            $(linkId).text("keine weiteren Artikel").addClass("disabled");
            /*if (language === "de") {
            } else {
              $(linkId).text("no more posts").addClass("disabled");
            }*/
          } else {
            pageNumber = 1;
            $("#more_search_posts").hide(); // This will hide the button once all posts have been loaded
            showContainer.html("");
            //$("#no-search-posts-found").show();
          }

          if (layout === 2) {
            showContainer.hide();
          }
        }
      },
      error: function () {
        //$loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      },
    });
    return false;
  }

  $("#at-ajax-search").on("focus", function () {
    $(this).attr("placeholder", $(this).data("placeholder")).addClass("active");
  });

  $(document).on("keyup", "#at-ajax-search", function () {
    if (this.value.length > 2) {
      load_posts("post", "#more_search_posts", this.value, 1);
      $("#more_search_posts").attr("data-searchvalue", this.value);
      $(".search-input-header__search-icon").hide();
      $(".search-input-header__close-icon").show();
    } else {
      $("#ajax-search-posts").hide();
      $(".search-input-header__search-icon").show();
      $(".search-input-header__close-icon").hide();
      //$("#ajax-search-posts").html("");
      //$("#more_search_posts").hide();
      pageNumber = 1;
    }
  });

  $(document).on("keyup", "#at-ajax-search-single", function () {
    if (this.value.length > 2) {
      load_posts("post", "#more_search_posts", this.value, 2);
      $(".search-input-single__search-icon").hide();
      $(".search-input-single__close-icon").show();
    } else {
      $("#ajax-search-posts-single").hide();
      $(".search-input-single__search-icon").show();
      $(".search-input-single__close-icon").hide();
    }
  });

  $("#more_search_posts").on("click", function (e) {
    e.preventDefault();
    load_posts(
      "post",
      "#more_search_posts",
      $(this).data("searchvalue"),
      1,
      true
    );
  });

  $(".search-overlay-cta").click(function (e) {
    e.preventDefault();
    $(".search-overlay").fadeIn();
    $(".search-overlay__search-field").focus();
  });

  $(".search-overlay__close").click(function (e) {
    e.preventDefault();
    $(".search-overlay").fadeOut();
  });

  /*  if ($("#at-ajax-search-single").length > 0) {
    document
      .getElementById("at-ajax-search-single")
      .addEventListener("search", function (event) {
        $("#ajax-search-posts-single").hide();
      });
  }*/

  $(".search-input-header__close-icon").click(function () {
    $(this).hide();
    $(".search-input-header__search-icon").show();
    $(".search-input-wrapper").removeClass("search-input-wrapper--active");
    $(".search-input-wrapper form").fadeOut();

    $("#at-ajax-search").val("");
    $("#ajax-search-posts").hide();
    $("#at-ajax-search-single").val("");
    $("#ajax-search-posts-single").hide();
  });

  $(".search-input-header__search-icon").click(function (e) {
    e.preventDefault();
    $(this).hide();
    $(".search-input-header__close-icon").show();
    $(".search-input-wrapper").addClass("search-input-wrapper--active");
    $(".search-input-wrapper form").fadeIn();
    $("#at-ajax-search").focus();
  });

  $(".search-input-single__close-icon").click(function () {
    $(this).hide();
    $(".search-input-single__search-icon").show();

    $("#at-ajax-search").val("");
    $("#ajax-search-posts").hide();
    $("#at-ajax-search-single").val("");
    $("#ajax-search-posts-single").hide();
  });

  /*
  $(".search-input-single__search-icon").click(function (e) {
    e.preventDefault();
    $(this).hide();
    $(".search-input-single__close-icon").show();
    $("#at-ajax-search-single").focus();
  }); */

  /*document
    .getElementById("at-ajax-search")
    .addEventListener("search", function (event) {
      $("#ajax-search-posts").hide();
    });*/
}
